'use client';

import Link from 'next/link';
import { motion } from 'framer-motion';
import { usePathname } from 'next/navigation';

interface NavItem {
  label: string;
  href: string;
}

interface NavbarProps {
  items: NavItem[];
  defaultRoute: string;
}

export default function Navbar({ items, defaultRoute }: NavbarProps) {
  let pathname = usePathname() || defaultRoute;

  if (pathname === '/') pathname = defaultRoute;

  return (
    <motion.nav
      className="hidden lg:flex space-x-6"
      aria-label="Main Navigation"
      role="navigation"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: 'easeOut' }}
    >
      <div className="tabs tabs-box shadow-md flex-nowrap overflow-x-auto bg-base-200">
        {items.map(({ label, href }) => (
          <motion.div
            key={href}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Link
              href={href}
              className={`tab px-10 font-medium transition-all ${
                pathname === href
                  ? 'tab-active bg-primary text-black'
                  : 'text-gray-800 hover:bg-gray-100'
              }`}
              aria-current={pathname === href ? 'page' : undefined}
            >
              {label}
            </Link>
          </motion.div>
        ))}
      </div>
    </motion.nav>
  );
}
